import { defineStore } from 'pinia'
import { ref } from 'vue'

export type ArrivalScene = 'arrival' | 'handover'

/** Which scene is due, armed by the router and disarmed once the shell has played it or the navigation fails. */
export const useArrivalStore = defineStore('arrival', () => {
  const scene = ref<ArrivalScene | null>(null)

  function arm(next: ArrivalScene): void {
    scene.value = next
  }

  function disarm(): void {
    scene.value = null
  }

  return { scene, arm, disarm }
})
